import { I18n } from '@calendly/i18n'
import { Button } from '@calendly/ui/components/button'
import { Body, Footer, Popup, Header } from '@calendly/ui/components/popup'

import ErrorMessage from 'components/core/error_message'

import { EmailVerification } from './email_verification'

export const Email2FAModal = ({ error = null, isSubmitting = false, onClose, onContinue, onErrorReset = () => {} }) => {
  const handleClose = () => {
    if (!isSubmitting) onClose()
  }

  const handleSubmit = ({ code }) => {
    onContinue({ code })
  }

  return (
    <Popup onClose={handleClose} title={I18n.t('publisher.email_2fa_modal.title')}>
      <Header>{I18n.t('publisher.email_2fa_modal.two_factor_auth_request')}</Header>
      <Body>
        <EmailVerification
          disabled={isSubmitting}
          handleSubmit={handleSubmit}
          error={error}
          reset={onErrorReset}
        />
        {!!error && <ErrorMessage message={error} />}
      </Body>
      <Footer>
        <Button decoration="secondary-outline" disabled={isSubmitting} onClick={handleClose}>
          {I18n.t('publisher.action.cancel')}
        </Button>
        {/* <Button onClick={onContinue}>{I18n.t('publisher.action.continue')}</Button> */}
      </Footer>
    </Popup>
  )
}
